import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanReadableDateTime',
  pure: true,
  standalone: false,
})
export class HumanReadableDateTimePipe implements PipeTransform {
  private readonly localeId = inject(LOCALE_ID);
  private readonly dateTimeFormatter = new Intl.DateTimeFormat(this.localeId || undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  transform(dbUtcTimestamp?: string | null): string {
    const utcDate = parseDatabaseUtcTimestamp(dbUtcTimestamp);
    return utcDate ? this.dateTimeFormatter.format(utcDate) : '';
  }
}

export function parseDatabaseUtcTimestamp(dbUtcTimestamp?: string | null): Date | null {
  if (!dbUtcTimestamp) {
    return null;
  }
  const trimmedTimestamp = dbUtcTimestamp.trim();
  if (!trimmedTimestamp) {
    return null;
  }
  const timestampMatch = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})\.(\d+)$/.exec(trimmedTimestamp);
  if (!timestampMatch) {
    return null;
  }

  const [, yearString, monthString, dayString, hourString, minuteString, secondString, fractionalSecondsString] =
    timestampMatch;
  const year = Number(yearString);
  const monthIndex = Number(monthString) - 1;
  const day = Number(dayString);
  const hour = Number(hourString);
  const minute = Number(minuteString);
  const second = Number(secondString);

  const milliseconds = Number(fractionalSecondsString.padEnd(3, '0').slice(0, 3));
  const utcDate = new Date(Date.UTC(year, monthIndex, day, hour, minute, second, milliseconds));
  return Number.isNaN(utcDate.getTime()) ? null : utcDate;
}
